import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom'
import { getBookmakerName } from '../utils/bookmaker-utilis';
import Flag from 'react-country-flag';
import FlagSpecial from './flag-special';
import { getCountryCode } from '../utils/country-code';
import { subscribeLivescores, closeSocket } from "../utils/web-socket";
import { translate } from '../utils/lang-adapters';

class AllMatchesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    subscribeLivescores((err, games) => {
      this.props.handleLivescores(games);
    });
  }

  componentWillUnmount() {
    closeSocket();
  }

  renderTime(gameData) {
    if (gameData.status === "Played"
      || (gameData.status === 'Playing' && typeof gameData.statusLive === 'undefined')) {
      return (
        <td className="clock">Terminado</td>
      )
    } else if (gameData.status === "Fixture") {
      return (
        <td className="clock">{gameData.time_utc.substring(0, 5)}</td>
      )
    } else if (gameData.status === 'Playing' && gameData.statusLive === 'Playing') {
      if (gameData.match_period === "HT") {
        return (
          <td className="clock live">Intervalo</td>
        )
      } else {
        return (
          <td className="clock live">
            {gameData.minute}{
              ([45, 90, 105, 120].includes(gameData.minute) && gameData.minute_extra > 0) &&
              (' + ' + gameData.minute_extra)
            }
            <span className="live-flash">'</span>
          </td>
        )
      }
    } else {
      return (<td className="clock">Cancelado</td>)
    }
  }

  renderResult(gameData) {
    if (gameData.status === "Played" || (gameData.status === 'Playing' && typeof gameData.statusLive === 'undefined')) {
      return (
        <td className="result">
          <div className="ft">{gameData.fs_A} - {gameData.fs_B}</div>
          {
            gameData.ets_A !== '' &&
            gameData.ets_B !== '' &&
            <div>(prol.{gameData.ets_A} - {gameData.ets_B})</div>
          }
          {
            gameData.ps_A !== '' &&
            gameData.ps_B !== '' &&
            <div>(pen.{gameData.ps_A} - {gameData.ps_B})</div>
          }
        </td>
      )
    } else if (gameData.status === "Fixture") {
      return (
        <td className="result"> - </td>
      )
    } else if (gameData.status === 'Playing' && gameData.statusLive === 'Playing') {
      return (
        <td className="result live">{gameData.fs_A} - {gameData.fs_B}</td>
      )
    } else { return (<td className="result"></td>) }
  }

  render() {
    return this.props.matches.map(each => {
      return (
        <tr
          key={each.match_id + "l"}
          className="gamestr"
          onClick={() => this.props.history.push("/match/" + each.match_id)}
        >
          <td className="competition-flag-icon ">
            {(getCountryCode(each.area_name) !== ""
              ? <Flag countryCode={getCountryCode(each.area_name)} svg loading="lazy" alt={'Bandeira de ' + each.area_name} className="flagsvg" />
              : <FlagSpecial code={each.area_name} />
            )}
          </td>
          <td className="competition-name">
            {
              translate(each.competition_name)
            }
          </td>
          {
            this.renderTime(each)
          }
          {
            (each.status === 'Playing' && each.statusLive === 'Playing' ?
              <td className="home-live">
                {
                  translate(each.team_A_name)
                }
              </td>
              :
              <td className="team home">
                {
                  translate(each.team_A_name)
                }
              </td>
            )
          }
          {
            this.renderResult(each)
          }
          {
            (each.status === 'Playing' && each.statusLive === 'Playing' ?
              <td className="away-live">
                {
                  translate(each.team_B_name)
                }
              </td>
              :
              <td className="team away">
                {
                  translate(each.team_B_name)
                }
              </td>
            )
          }
          <td className="stats-mobile">
            <Link to={"/match/" + each.match_id}>
              <div className="switch-stats"></div>
            </Link>
          </td>
          <td className="streaming">
            <div className="text-streaming">
              {
                typeof each.zapping !== 'undefined' && each.zapping.length > 0
                &&
                each.zapping.map((channel, index) => {
                  const bookmakerName = getBookmakerName(channel.zapping_name);
                  return (
                    <span key={index} className="channel">
                      {
                        bookmakerName === 0 ?
                          (
                            <div className="text-channel">{channel.zapping_name}
                              <b>, </b>
                            </div>
                          ) :
                          (
                            <a href={"https://www.academiadasapostas.com/redirect/" + bookmakerName} target="_blank" rel="noopener noreferrer">
                              <div className="text-channel">{channel.zapping_name}
                                <b>, </b>
                              </div>
                            </a>
                          )
                      }
                    </span>
                  );
                })
              }
            </div>
          </td>
          <td className="liveText-mobile">
            {each.status === 'Playing' && each.statusLive === 'Playing' &&
              <b className="liveText">LIVE</b>
            }
          </td>
        </tr>
      );
    })
  }
}

export default withRouter(AllMatchesPage);